
import App from "./App.vue";
import { createI18n } from "vue-i18n";
import messages from "./messages";

import "./assets/styles/main.scss";
import 'jquery-ui/themes/base/all.css';


// BackToTop
import BackToTop from 'vue-backtotop';

import Vuelidate from '@vuelidate/core';

// Axios
import axios from 'axios';
import { BootstrapVue3 } from "bootstrap-vue-3";

async function loadEnvConfig() {
  try {
    const response = await fetch("/bundlepengconf.txt");
    if (!response.ok) throw new Error("bundlepengconf.txt not found");

    const encoded = await response.text();
    let decoded = atob(encoded.trim());
    decoded = decoded.replace(/[\r\n]+/g, "");
    window.env = JSON.parse(decoded);
  } catch (err) {
    console.error("Failed to load config:", err);
    window.env = {};
  }
}

(async () => {
  await loadEnvConfig();

  // Import Vue only after env is ready
  const { createApp } = await import("vue");
  const { default: router } = await import("./router");
  const { default: store } = await import("./store");

  // Axios setup
  axios.interceptors.request.use(
    function (config) {
      config.withCredentials = true;
      return config;
    },
    function (err) {
      return Promise.reject(err);
    }
  );

  // Vue I18n
  const i18n = createI18n({
    legacy: false,
    locale: "sr-RS",
    messages,
    numberFormats: {
      "sr-RS": {
        currency: {
          style: "currency",
          currency: "RSD",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
      en: {
        currency: {
          style: "currency",
          currency: "RSD",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  });

  // Create app
  const app = createApp(App);

  app.mixin({
    methods: {
      getStoredLanguage() {
        return localStorage.getItem("language") || "en";
      },
      setLanguage(lang) {
        localStorage.setItem("language", lang);
        if (this.$i18n) this.$i18n.locale = lang;
      },
    },
    created() {
      const storedLanguage = this.getStoredLanguage();
      this.setLanguage(storedLanguage);
    },
  });

  // Use plugins
  app.use(router);
  app.use(store);
  app.use(i18n);
  app.use(BootstrapVue3);
  app.use(Vuelidate);

  app.component("BackToTop", BackToTop);

  app.mount("#app");
})();